import { IsUUID, IsNotEmpty, IsArray } from 'class-validator'
import { ApiProperty } from '@nestjs/swagger'

/**
 * DTO for batch lookup of program concepts by IDs
 */
export class ProgramConceptLookupDto {
  @ApiProperty({
    description: 'List of ProgramConcept UUIDs to lookup',
    type: [String],
    example: ['550e8400-e29b-41d4-a716-446655440000'],
  })
  @IsArray()
  @IsUUID('4', { each: true })
  @IsNotEmpty()
  ids!: string[]
}

/**
 * DTO for fetching program concepts with their linked competencies
 */
export class ProgramConceptWithCompetenciesDto {
  @ApiProperty({
    description: 'List of ProgramConcept UUIDs',
    type: [String],
    example: ['550e8400-e29b-41d4-a716-446655440000'],
  })
  @IsArray()
  @IsUUID('4', { each: true })
  @IsNotEmpty()
  programConceptIds!: string[]
}
